"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullDefault = void 0;
/**
 * sprawdza czy wartośc jest null, jeśli tak to zwraca valueIfNull
 * @param value wartość do sprawdzenia
 * @param valueIfNull co ma zwracać gdy value === null
 */
function nullDefault(value, valueIfNull) {
    return value === null ? valueIfNull : value;
}
exports.nullDefault = nullDefault;
//# sourceMappingURL=nullDefault.js.map